import React from "react";
import styled, { useTheme } from 'styled-components';
import { useMediaQuery } from "react-responsive";
import { useNavigate } from 'react-router-dom';
import { MainContainer } from '../common/Containers';
import FAQList from '../common/FAQList';
import { joiningFaqs, contributionsFaqs, miscFaqs } from '../../data/faqs';

export default function PoolFAQ() {
    const theme = useTheme();
    const isMobile = useMediaQuery({ maxWidth: 600 });
    // Navigate
    // const navigate = useNavigate();

    return (
        <MainContainer theme={theme}>
            <Section>
                {/* Previous FAQ mapping commented out
                {faqs.map((faq, index) => (
                    <Card
                        key={index}
                        onClick={() => navigate("/dashboard/faqs")}
                        style={{
                            cursor: "pointer",
                            transition: "transform 0.2s ease-in-out",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.01)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                    >
                        <Left>
                            <Title>{faq.title}</Title>
                            <Answer>{faq.answer}</Answer>
                        </Left>

                        <Right><Image src={faq.image} alt={faq.title} /></Right>
                    </Card>
                ))}
                */}
                <Header style={{ marginTop: "0rem" }}>
                    <h2 style={{ color: theme.textPrimary, fontSize: isMobile ? "1.15rem" : "1.5rem" }}>
                        Joining a Success Pool
                    </h2>
                </Header>
                <FAQList faqs={joiningFaqs} />

                <Header>
                    <h2 style={{ color: theme.textPrimary, fontSize: isMobile ? "1.15rem" : "1.5rem" }}>
                        Contributions and Distributions
                    </h2>
                </Header>
                <FAQList faqs={contributionsFaqs} />

                <Header>
                    <h2 style={{ color: theme.textPrimary, fontSize: isMobile ? "1.15rem" : "1.5rem" }}>
                        Miscellaneous Questions
                    </h2>
                </Header>
                <FAQList faqs={miscFaqs} />
            </Section>
        </MainContainer>
    );
}

// Styled Components
const Section = styled.div`
    width: "100%";
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 0.5rem;
    background: ${({ theme }) => theme.white};
    padding: 2rem;
    border-radius: 1.5rem;
    flex-wrap: wrap;

    @media (max-width: 600px) {
        padding: 2rem 1rem;
        gap: 1rem;
    }
`;

const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    flex-wrap: wrap;
    margin-top: 2rem;

    @media (max-width: 600px) {
        align-items: center;
    }
`;

// Keeping these styled components for now in case we need them later
const Card = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    border-radius: 1.5rem;
    background: ${({ theme }) => theme.white};
    width: 100%;
    overflow: hidden;

    @media (max-width: 1000px) {
        width: 100%;
    }

    @media (max-width: 600px) {
        flex-direction: column;
    }
`;

const Left = styled.div`
    padding: 1.5rem 2rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    @media (max-width: 600px) {
        padding: 1.5rem 1.25rem;
    }
`;

const Title = styled.h3`
    font-size: 1.375rem;
    font-weight: 500;
    color: ${({ theme }) => theme.textPrimary};
    margin-bottom: 0.5rem;

    @media (max-width: 600px) {
        font-size: 1.0625rem;
    }
`;

const Answer = styled.p`
    font-size: 1rem;
    font-weight: 400;
    color: ${({ theme }) => theme.textSecondary};
    line-height: 1.5rem;
    margin: 0;
`;

const Right = styled.div`
    width: 32%;
    height: auto;
    display: flex;
    align-items: stretch;
    justify-content: center;
    flex-shrink: 0;

    @media (max-width: 600px) {
        width: 100%;
        height: auto;
    }
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;

// Previous FAQ data commented out
/*
const faqs = [
    {
        title: "Joining a Success Pool",
        answer: "How does the Trial Period work? Can new members be added? If you have questions about the mechanics of joining a pool, click here.",
        image: "/assets/faq1.png",
    },
    {
        title: "Contributions and Distributions",
        answer: "Understand the contribution/distribution cycle every year, how we verify income, and how the Success Pooling Agreement and Prospinity ensure that pools run smoothly…",
        image: "/assets/faq2.png",
    },
    {
        title: "Miscellaneous Questions",
        answer: "We get a lot very nuanced and specific questions! You might find what you are looking for here. Topics covered include how pools connect, the economic ideas behind pooling, and more…",
        image: "/assets/faq3.png",
    },
];
*/
